import * as React from "react";
import { forwardRef } from "react";
const SvgCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 23, viewBox: "0 0 28 125", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("line", { x1: 13.5, y1: 124.039, x2: 13.5, y2: 8.99994, stroke: "black", strokeWidth: 7 }), /* @__PURE__ */ React.createElement("circle", { cx: 14, cy: 14, r: 14, fill: "black" }));
const ForwardRef = forwardRef(SvgCircle);
export default ForwardRef;
